import React, { useState, useEffect, useRef } from 'react';
import { useLocation,useParams,useNavigate } from 'react-router-dom';
import axios from 'axios';
import SignaturePad from 'react-signature-pad-wrapper';

import { useFileFetch } from '../hooks/useFileFetch';
import { 
    createPermanentContract_URL,
    showContract_URL,
    signContract_URL,
    showFile_URL,
    SHOWWCL2_URL,
    signFile_URL,
} from '../config';
import useAuth from '../hooks/useAuth';
import Header from './Header';
import PdfComp from './PdfComp';
import Knoppie from './Knoppie';
import ButtonGrid from './ButtonGrid';

const PdfView = (props) => {
    const auth = useAuth();
    const location = useLocation();
    
    const {pickedfilename} = useParams()

    const [pdfFile, setPdfFile] = useState(null);
    const [filename, setFilename] = useState(pickedfilename);
    const [loading, setLoading] = useState(false); // Loading state
    const [sign, setSign] = useState(false);
    const signaturePadRef = useRef(null); // Create a ref for SignaturePad
    const canvasRef = useRef(null);
    const [signaturePosition, setSignaturePosition] = useState(null);
    const [documentURL, setDocumentURL] = useState(null)
    const [filelocation,setFileLocation] =useState()
    const {id,type} = useParams();
    const { state, error } = useFileFetch(id);
    const [errorMessage, setErrorMessage] = useState(false);
    const navigate = useNavigate();
    const [scale, setScale] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    
    const from = location.state?.from || "./";

    console.log(location.state?.from)

    
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber); // Update the page number when it changes
        console.log("Current page in PdfView:", pageNumber); // Optional: Log or use as needed
      };
    useEffect(() => {
        const initializeAndFetchPDF = async () => {
            // Step 1: Determine the documentURL
            setLoading(true);

            console.log("Binne initialize and Fetch")
            const url = type === 'employee' ? showContract_URL :
                        type === 'IOD' ? SHOWWCL2_URL :
                        showFile_URL;
            setDocumentURL(url);
    
            console.log("Die url is "+url+" and id is " + id)
           
            // Step 2: Wait for documentURL and fetch the PDF
            if (!id) {
                console.error('No ID found, cannot fetch PDF');
                return;
            }
            const fetchUrl = `${url}/show/${id}`;
       
        
            try {
                
                setLoading(true)
               
                // Fetch the PDF file as a blob using the fetch API

                console.log(`${fetchUrl}/${filename}`)

                const response = await fetch((`${fetchUrl}/${filename}`), {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + auth.auth.accessToken,
                    }
                });
        
                if (!response.ok) {
                    throw new Error("Failed to fetch PDF");
                }
        
                // Extract the Content-Disposition header from the response headers
               
                const contentDisposition = response.headers.get('content-disposition');
                console.log("Content-Disposition header:", contentDisposition);
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {

                    console.log("Binne die if contentDisposition")
                    const filenameMatch = contentDisposition.match(/filename(?:\*=UTF-8'')?=(?:"([^"]+)"|([^;]+))/);

                    console.log(filenameMatch)
                    var name =""
                    if (filenameMatch && filenameMatch[2]) {

                      name = filenameMatch[1] || filenameMatch[2];
                    }else{
                      name = ""
                    }
                  }

                console.log("filename = "+ name)  
                // Get the PDF blob from the response
                const blob = await response.blob();
        
                // If you want to display it in an iframe, uncomment the following:
                const url =  URL.createObjectURL(blob);
                setPdfFile(url);
                setFilename(name)  
                // If you want to download the file:
                // const filename = contentDisposition ? contentDisposition.split('filename=')[1] : 'contract.pdf';
                // const url = URL.createObjectURL(blob);
                
                // Trigger a download
                // const a = document.createElement('a');
                // a.href = url;
                // a.download = filename; // Use filename from the header or default
                // a.click();
            } catch (error) {
                console.log("Fout by getPDF catch in PDFView")
                console.error(error);
                setLoading(false);
            } finally {
                setLoading(false); // Turn off loading when request is finished
            }
        };
        
        // Trigger the function if the ID is present
       
        initializeAndFetchPDF()
      
    }, [id, auth.auth.accessToken,type]);

    useEffect(() => {
        const handleResize = () => {
          if (canvasRef.current) {
            const { offsetWidth } = canvasRef.current;
            const newScale = offsetWidth / 595; // Assume 595 is the PDF's original width
            setScale(newScale);
          }
        };
    
        window.addEventListener("resize", handleResize);
        handleResize();
    
        return () => window.removeEventListener("resize", handleResize);
      }, []);

    const handleClick = () => {
        console.log("Binne handle click");
        if(signaturePosition===null){

            alert("please click on the pdf to show where you would like to place the signature")
            
        }else{

            setSign(true);
        }
    };

    const handleLocation = (event) => {
       
        if (canvasRef.current) {
        const rect = canvasRef.current.getBoundingClientRect(); // Get canvas bounds
        console.log(rect)
        console.log(canvasRef.current.offsetWidth)
        console.log(canvasRef.current.offsetHeight)
        console.log("eventX = "+event.clientX)
        console.log("eventY = "+event.clientY)
        
        console.log(scale)
        console.log(window.scrollY)
        
        const mouseX = (event.clientX - ((canvasRef.current.offsetWidth-375)/2)-10)*595/356;
        // const mouseY = (event.clientY - ((rect.y)*840/canvasRef.current.offsetHeight));
     
        // const mouseX = ((event.clientX - rect.left) / scale)*595/380;
        const mouseY = 840-(((event.clientY + window.scrollY)-225)*840/503);
        // Update the signature position with mouse click coordinates
        setSignaturePosition({ x: mouseX, y: mouseY, screenX: event.pageX, screenY: 540-event.pageY });
        console.log("die position is x "+mouseX+" en y "+mouseY)
        setSign(true)
        }else{
            console.error("canvasRef is null!");
        }
       
      };

    const handleDownload = ()=>{
        if(!pdfFile)throw new Error("No PDF File available to download")
        const link = document.createElement('a');
        link.href = pdfFile;
        link.download = state.name; // Name of the file to be downloaded
        link.click();   
        
    }
      
    const onSave = async () => {
        // Access the signature pad via ref and save the signature (or extract the data)
        setLoading(true)
        const signaturePad = signaturePadRef.current;
        if(signaturePosition===null){
            
                alert("please click on the pdf to show where you would like to place the signature")
                signaturePad.clear()
                setSign(false)
                setLoading(false)
                return
       
        }else{
        if (signaturePad) {
                const dataURL = signaturePad.toDataURL(); // Method to extract signature data (base64)
                console.log("Signature saved:", dataURL);
                    // Create a new image element
                    const image = new Image();
                    image.src = dataURL; // Set the source of the image to the data URL

                    image.onload = async () => {
                                // Create a canvas to draw the image onto
                                const canvas = document.createElement('canvas');
                                const ctx = canvas.getContext('2d');
                                
                                // Set canvas dimensions to match the image size
                                canvas.width = image.width;
                                canvas.height = image.height;

                                // Draw the image onto the canvas
                                ctx.drawImage(image, 0, 0);

                                // Convert the canvas to a JPEG data URL
                                const jpegDataUrl = canvas.toDataURL('image/jpeg', 1.0); // Quality is set to 1.0 (highest)
                                    
                                
                                console.log(jpegDataUrl); // This is the JPEG data URL
                                // You can use this JPEG data URL to save or display the image
                                console.log(documentURL+"/sign/"+id)
                                try {
                                    const response = await fetch(`${documentURL}/sign/${id}`, 
                                        {method: 'POST', 
                                        headers: {
                                            "content-type" : "application/json",
                                            'authorization': 'Bearer '+auth.auth.accessToken
                                        },
                                        body: JSON.stringify({file: dataURL, filename:filename, signpos: signaturePosition, page:currentPage})
                                        }
                                    );   
                                    if (!response.ok) {
                                        throw new Error("Failed to fetch PDF");
                                    } 
                                    const blob = await response.blob();
                
                                const url = URL.createObjectURL(blob);
                                setPdfFile(url);
                                signaturePad.clear()
                                setSign(false)
                                setLoading(false)
                                setSignaturePosition(null)
                                } catch (error) {
                                    console.log(error)
                                   
                                }
                               
                                
                                
                    };

                    image.onerror = (err) => {
                    console.error('Error loading image for conversion:', err);
                    
                    };
            
                    
            
        }else{
            console.log("no signaturePad found")
        }
    }
    };

    const onClear = () => {
        // Access the signature pad via ref and clear the signature
        const signaturePad = signaturePadRef.current;
        if (signaturePad) {
            signaturePad.clear(); // Clear the signature pad
        }
    };
    const onCancel = () => {
        // Access the signature pad via ref and clear the signature
        const signaturePad = signaturePadRef.current;
        if (signaturePad) {
            signaturePad.clear(); // Clear the signature pad
        }
        setSign(false)
    };
    
    return (
        <>
            <Header destination={from} />
            <ButtonGrid header={"Actions"}>
                <Knoppie clickable={true} text={"Sign Document"} callback={handleClick} />
                <Knoppie clickable={true} text={"Download"} callback={handleDownload}/>
                <Knoppie text={""} />
                <Knoppie text={""} />
                <Knoppie text={""} />
                <Knoppie text={""} />
                <Knoppie text={""} />
            </ButtonGrid>
            
           {state.signed?<div>This file has been signed previously</div>:<div>Not signed yet</div>}

            {loading ? (
                <div>Loading...</div>
            ) : (
                pdfFile ? (<PdfComp 
                pdffile={pdfFile} 
                ref={canvasRef} 
                callback={handleLocation}
                onPageChange={handlePageChange}
                /> 
                ): (<div>No PDF available at PdfView</div>)
            )}

            
          
                <div className= {`Signature-container ${sign ? 'slide-in':''}`}>
                    <div>Sign here:</div>
                    <SignaturePad 
                        redrawOnResize
                        ref={signaturePadRef} // Use the ref here
                        canvasProps={{
                            className:'signature-canvas'
                        }}
                    />
                    {errorMessage?<div>It appears as if you scribbled on the pad. We could not process this signature. Please sign shorter.</div>:""}
                    <ButtonGrid>
                        <Knoppie clickable={true} callback={onSave} text={'Save'} />
                        <Knoppie clickable={true} callback={onClear} text={'Clear'} />
                        <Knoppie clickable={true} callback={onCancel} text={'Cancel'} />

                    </ButtonGrid>
                </div>
         
        </>
    );
};

export default PdfView;
